import React from 'react'
import { t } from 'ttag'
import { Link } from 'react-router-dom'

import like from '@h2/assets/svg/icons/thumbsUpActive.svg'
import likeInactive from '@h2/assets/svg/icons/thumbsUpInactive.svg'
import dislike from '@h2/assets/svg/icons/thumbsDownActive.svg'
import dislikeInactive from '@h2/assets/svg/icons/thumbsDownInactive.svg'

import { rateCluster } from '../../../actions/clusterProfile'

class ProfileSectionAutoCluster extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      additional: []
    }
  }

  componentDidMount() {
    this.setState({
      additional: this.props.section.additional
    })
  }

  updateStateWith = (item, newRating) => {
    const addl = [...this.state.additional]
    const idx = addl.indexOf(item)

    if (idx >= 0) {
      const newItem = {
        ...item,
        flag: newRating
      }
      const retVal = [...addl.slice(0, idx), newItem, ...addl.slice(idx + 1)]

      // console.log(retVal, addl, idx);
      this.setState({
        ...this.state,
        additional: retVal
      })
    }
  }

  makeActions = itm => {
    // console.log(itm)
    const recommendation = itm?.flag ?? {}
    const thumbUp =
      recommendation.rating && recommendation.rating >= 3 ? like : likeInactive
    const thumbDown =
      recommendation.rating && recommendation.rating < 3 ? dislike : dislikeInactive

    return (
      <div style={{ whiteSpace: 'nowrap', width: '40px', textAlign: 'right' }}>
        <a
          style={{
            marginRight: '3px',
            color: recommendation.rating && recommendation.rating > 3 ? '#aaa' : '#ddd',
            cursor: 'pointer'
          }}
          onClick={() =>
            this.props
              .dispatch(rateCluster(itm, 5))
              .then(v => this.updateStateWith(itm, v))}>
          <img
            src={thumbUp}
            alt={t`Thumbs Up for Like Link`}
            style={{ maxWidth: '17px' }}
          />
        </a>
        <a
          style={{
            color: recommendation.rating && recommendation.rating <= 3 ? '#aaa' : '#ddd',
            cursor: 'pointer'
          }}
          onClick={() =>
            this.props
              .dispatch(rateCluster(itm, 1))
              .then(v => this.updateStateWith(itm, v))}>
          <img
            src={thumbDown}
            alt={t`Thumbs Down for Dislike Link`}
            style={{ maxWidth: '17px' }}
          />
        </a>
      </div>
    )
  }

  defaultThumb = s => {
    if (!s.image) {
      return null
    }

    return (
      <img
        className="img-rounded"
        width={'100%'}
        height={'100%'}
        src={s.image}
        aria-hidden="true"
        alt={t`Thumbnail for ${s.title}`}
      />
    )
  }

  render() {
    const { section, expanded, dispatch, hideDescription } = this.props

    //console.log(section, !!section.additional)
    if (!this.state.additional || !this.state.additional.length) {
      return (
        <div className="text-center">
          <i>{t`No clusters currently have offerings to match this work based learning type`}</i>
        </div>
      )
    }

    if (expanded) {
      return (
        <div>
          <p>{t`The following ${dynamicValues.clusterTaxonomyTitle} have been associated with companies that may offer opportunities in these areas.`}</p>
          {this.state.additional.map((s, idx) => (
            <div
              key={`media.${s.url}`}
              style={{ borderBottom: '1px solid #eee', padding: '15px' }}
              className={`cluster-listing-icon row ${idx % 2 == 0 ? 'even' : 'odd'}`}>
              <Link to={s.url}>
                <div
                  className="col-xs-2 col-md-1"
                  style={{ paddingLeft: '5px', paddingRight: '5px' }}>
                  {this.defaultThumb(s)}
                </div>
                <div className="col-xs-8 col-md-9">{s.title}</div>
              </Link>
              <div className="col-xs-2">{this.makeActions(s)}</div>
            </div>
          ))}
        </div>
      )
    }

    return (
      <ul className="list">
        {' '}
        {this.state.additional.map((s, idx) => (
          <li className="item" key={`additional-detail-${idx}`}>
            <Link to={s.url}>{s.title}</Link>
          </li>
        ))}{' '}
      </ul>
    )
  }
}

export default ProfileSectionAutoCluster
